import reminderSoundUrl from '@/assets/audio/reminder.mp3'
import { createReminderSoundController } from './reminderSoundCore'

const controller = createReminderSoundController({
  audioFactory: () => new Audio(reminderSoundUrl)
})

export const setupReminderSoundUnlock = controller.setupReminderSoundUnlock
export const playReminderSound = controller.playReminderSound
